import {PRODUCT_NAME} from '#/lib/brand'

export function bskyTitle(page: string, unreadCountLabel?: string) {
  const unreadPrefix = unreadCountLabel ? `(${unreadCountLabel}) ` : ''
  return `${unreadPrefix}${page} — ${PRODUCT_NAME}`
}
